import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PostImage"] */ "/vercel/path0/src/app/(main-layout)/blog/(page-layout)/page/[page]/components/post-image.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/blog-fallback.png");
